var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Fill_1","data-name":"Fill 1","d":"M12,24A12,12,0,0,1,3.515,3.515a12,12,0,1,1,16.97,16.97A11.922,11.922,0,0,1,12,24ZM8,10v2h2v7h3V12H14.79L15,10H13V8.778C13,8.24,13.093,8,13.65,8H15V5H13.029C10.991,5,10,5.881,10,7.692V10Z","transform":"translate(0 0)"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
